<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="SearchIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="selectRecord"  />
    </div>
</template>

<script>
export default {
  name: 'CellMuckActions',
  methods: {
    selectRecord () {
      this.params.context.componentParent.selectLocationForecast(this.params.data);
    }
  }
}
</script>
